var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 114,
    viewBox: "0 0 123 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.42 66.81V95.81H17.5L3 110.32V43.61H43.61M43.61 55.21H104.52L119.02 69.71V3H43.61V55.21Z",
    stroke: "#134263",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_16_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.4 27.9H107.71",
    stroke: "#134263",
    strokeWidth: 5.801,
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeDasharray: "8.76 8.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 72.9H66.31",
    stroke: "#134263",
    strokeWidth: 5.801,
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeDasharray: "8.76 8.76"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122.02,
    height: 113.32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_16_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90.71,
    height: 50.8,
    fill: "white",
    transform: "translate(17 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.c6c63675c9ddb84cb11563e9af185482.svg";
export { ForwardRef as ReactComponent };